export default __webpack_public_path__ + "static/client5-962e5b25cd1f247c386382ce0b29bd73.svg";